module.exports = __webpack_public_path__ + "img/icon_map_xiaofangshuan_zaixian.708b9efb.svg";